<template>
  <!-- <div class="guessYouLikeBody" v-if="dataSource.length > 0">
    <van-row>
      <van-col class="guessYouLike" span="24">猜你喜欢</van-col>
    </van-row>
    <van-row
      v-for="(item, index) in dataSource"
      :key="index"
      class="guessContent"
      @click="handleReserve(item)"
    >
      <van-col span="7">
        <div class="img-box">
          <img :src="item.picture" class="guess_img" />
        </div>
      </van-col>
      <van-col span="2"></van-col>
      <van-col span="15" class="guess_right" id="">
        <div>
          <p class="guess_name">
            {{ item.chinese_name }}
            <span class="guess_type">{{ item.star_name }}</span>
          </p>

          <p>
            <span class="guess_score">{{ item.ratings }}</span
            ><span class="guess_page">{{ item.page_view }}</span
            ><span class="guess_browse">浏览量</span>
          </p>
          <p>
            <span class="guess_distance">距您{{ item.distance }}m</span>
          </p>
          <div class="guess_advantage_body" v-if="item.labels[item.labels.length-1]!==''">
            <p
              v-for="(adv, index) in item.labels"
              :key="index"
              class="tag_box tag_body"
            >
              <span v-if="adv!==''"> {{ adv }}</span>
            </p>
          </div>
          <p class="money_body">
            <span class="money_logo">¥</span
            ><span class="guess_money">{{ item.price }}</span
            ><span class="guess_rise">起</span>
          </p>
        </div>
      </van-col>
    </van-row>
  </div> -->
  <div class="datail-bottom">
    <div class="room-read may-like">猜你喜欢</div>
          <div class="may-list-product-list">
            <productlist
              v-for="(item, index) in dataSource"
              :key="index"
              :setData="item"
              @toggle="godetail"
            />
          </div>
          </div>
</template>

<script>
import "@/assets/hotel/css/reset.css";
import { getGuessOrderList } from "@/pages/hotel/api";
import productlist from "../components/product-list.vue";
export default {
  name: "guessOrder",
  data() {
    return {
      dataSource: [],
      coordinate :{},
    };
  },
  props: {
    hotel_id: {
      type: String,
    },
  },
  created() {
    if(sessionStorage.coordinate){
          this.coordinate = JSON.parse(sessionStorage.getItem("coordinate"));
      }
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.onLoad();
  },
  components: {
    productlist
  },
  methods: {
        godetail(hotel_id) {
        this.$router.push({
          path: "/hotel/detail",
          query: {
            hotel_id: hotel_id,
          },
        });
    },
    onLoad() {
     //  sessionStorage.setItem("longitude", "116.481777");
    //   sessionStorage.setItem("latitude", "39.910844");
      const coordinate = JSON.parse(sessionStorage.getItem("coordinate"));
      getGuessOrderList({
        longitude:this.coordinate && this.coordinate.longitude || "116.481777",
        latitude:this.coordinate && this.coordinate.latitude || "39.910844",
        // longitude: sessionStorage.getItem("longitude"),
        // latitude: sessionStorage.getItem("latitude"),
        hotel_id: this.hotel_id,
      })
        .then((res) => {
          for (let i in res.list) {
            let titleArr = res.list[i].label.split(",");
            if (titleArr.length > 2) {
              //  titleArr.map(item=>{
              //    if(item.length)
              //  })
            }
            if (titleArr.length > 4) {
              titleArr.splice(4);
            }
            res.list[i].labels = titleArr;
          }
          this.dataSource = res.list;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    // handleReserve(val) {
    //   this.$router.push({
    //     path: "/hotel/detail",
    //     query: {
    //       hotel_id: val.hotel_id,
    //       back: "order",
    //     },
    //   });
    // },
    reBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
.may-like {
  padding: 3rem 0 0 0;
}
.datail-bottom {
  padding: 2rem 1.5rem 0;
  .room-read {
    height: 2.5rem;
    font-size: 1.8rem;
    font-weight: 600;
    color: #333333;
    line-height: 2.5rem;
    position: relative;
    img {
      width: 2rem;
      height: 2rem;
      position: relative;
      top: 0.2rem;
      margin-right: 0.5rem;
    }
  }
  .read-text {
    height: 2.1rem;
    font-size: 1.5rem;
    font-weight: 600;
    color: #333333;
    line-height: 2.1rem;
  }
  .second-read {
    padding: 0.5rem 0 0rem 2rem;
    word-break: break-word;
    height: auto;
  }
  .deail-right-text {
    position: absolute;
    top: 0;
    right: 0;
    height: 1.7rem;
    font-size: 1.2rem;
    font-weight: 600;
    color: #666666;
    line-height: 1.7rem;
    img {
      width: 0.8rem;
      height: 0.8rem;
      margin-bottom: 0.2rem;
    }
  }
}

.may-list-product-list {
  padding-bottom: 6rem;
  .product {
    padding-right: 0;
    padding-left: 0;
  }
}




// .guessContent {
//   display: flex;
//   margin-bottom: 1.5rem;
//   .img-box {
//     border-radius: 1rem;
//     overflow: hidden;
//     height: 100%;
//     img {
//       display: inline-block;
//       width: 100%;
//       height: 98%;
//       object-fit: cover;
//     }
//   }
//   .guess_right {
//     // min-height: 165rem;
//     border-bottom: 1px solid #dddddd;
//   }
//   .guess_name {
//     color: #333;
//     font-size: 1.6rem;
//     font-weight: bold;
//   }
//   .guess_type {
//     font-size: 1.2rem;
//     color: #666;
//     font-weight: normal;
//   }
//   .guess_score {
//     font-size: 2rem;
//     color: #108b30;
//     font-weight: bold;
//   }
//   .guess_page {
//     color: #f49103;
//     font-size: 1.3rem;
//     margin-left: 1rem;
//     margin-right: 0.6rem;
//     font-weight: bold;
//   }
//   .guess_browse {
//     color: #999999;
//     font-size: 1.3rem;
//   }
//   .guess_distance {
//     font-size: 1.1rem;
//     color: #666;
//   }
//   .guess_advantage_body {
//     display: flex;
//     margin-top: 0.6rem;
//     flex-wrap: wrap;
//     width: 100%;
//     overflow: hidden;
//     height: 2.3rem;
//   }
//   .tag_body {
//     padding: 0 0.2rem;
//     height: 2rem;
//     text-align: center;
//     line-height: 2rem;
//     border-radius: 0.4rem;
//     margin-bottom: 0.4rem;
//   }
//   .tag_box {
//     span {
//       transform: scale(0.6);
//       font-size: 1.2rem;
//     }
//   }
//   .tag_box:nth-child(1) {
//     color: #108b30;
//     border: 1px solid #108b30;
//   }
//   .tag_box:nth-child(2) {
//     color: #f49103;
//     margin-left: 0.7rem;
//     border: 1px solid #f49103;
//   }

//   .tag_box:nth-child(3) {
//     color: #ff6253;
//     margin-left: 0.7rem;
//     border: 1px solid #ff6253;
//   }

//   .tag_box:nth-child(4) {
//     color: #00a9ff;
//     margin-left: 0.7rem;
//     border: 1px solid #00a9ff;
//   }
//   .money_body {
//     text-align: right;
//     margin-top: 1rem;
//     margin-bottom: 1rem;
//   }
//   .money_logo {
//     font-size: 1.2rem;
//     color: #f84737;
//   }
//   .guess_money {
//     font-size: 2.2rem;
//     color: #f84737;
//     font-weight: bold;
//     margin: 0 0.2rem 0.5rem;
//   }
//   .guess_rise {
//     color: #999999;
//     font-size: 1.2rem;
//   }
// }
// .guessYouLikeBody {
//   width: calc(100% - 2rem);
//   margin: 0 auto;
//   .guessYouLike {
//     color: #333333;
//     font-size: 1.8rem;
//     font-weight: bold;
//     margin: 3rem 0 2rem;
//   }
// }
// .guessContent:last-child {
//   margin-bottom: 2rem;
//   .guess_right {
//     border-bottom: none;
//   }
// }
.isiOSX {
  padding-top: 44px;
}
</style>
